

// @file wu-price-corridor-service.js
// @description This file contains the service to fetch price corridors based on country and currency.
window.countryPartnerIds = {
    "TH": "WGBSTHD000P",
    "TG": "WGWDTG9960P",
    "SN": "WGWDSN9980P",
    "SA": "WGBSSAN081P",
    "QA": "WGBSQAK951P",
    "MV": "WGBSMVD000P",
    "KW": "WGBSKWK931P",
    "JO": "WGBSJOD000P",
    "BH": "WGBSBHL411P",
    "AE": "WGBSAEL951P",
    "default": "R3WEB9Z00"
}
/**
 * @function to call country currencies
 * @param var senderCountry and senderCurrency 
 * @returns  all the currencies
 */

const triggerPriceCorridorList = (senderCountry, senderCurrency) => {
    try {
        const country = senderCountry.toUpperCase();
        const currency = senderCurrency.toUpperCase();
        const host = getHttpRequestUrl(`${window.location.origin}/`)
        const url = `${host}wuconnect/rest/api/v1.0/price/corridors/${country}/${currency}`
        const headerObj = {
            partnerId: window.countryPartnerIds[country] || window.countryPartnerIds.default
        }
        const initPriceCorridorApi = () => {
            return new Promise((resolve) => {
            httpRequest.get(url, headerObj)
                .then((response) => {
                    resolve(response)
                })
            });
        }
        return {
            initPriceCorridorApi
        }
    } catch (e) {
        console.warn('Error in price corridor api', e)
    }
}
